import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import format from 'date-fns/format'

type Props = {
  currentMonth: Date
}

const ScheduleCollectiveLabel: FC<Props> = React.memo((props) => {
  const { currentMonth } = props

  return <p className={styles.label__monthly}>{format(currentMonth, 'yyyy年M月')}</p>
})

export default ScheduleCollectiveLabel
